/**
 * Algolia 검색 결과에서 "몇 개까지 노출했는지"를 sessionStorage 에 들고 있는다.
 *
 * hits 는 infiniteHitsCache 가 복구해 주지만 노출 개수는 컴포넌트 state 라, 목록 → 상세 → 뒤로가기로
 * 돌아오면 한 페이지 분량으로 줄어든다. 그러면 문서 높이가 달라져 브라우저 스크롤 복원이 어긋난다.
 *
 * stateKey 는 검색어 · 정렬 · 필터를 합친 문자열이다. 저장할 때 같이 넣어 두고 읽을 때 비교해서,
 * 다른 조건으로 들어온 경우에는 복구하지 않고 첫 페이지부터 보여 준다.
 */
const VISIBLE_COUNT_KEY = "search_visible_count";

export function readVisibleCount(stateKey: string, pageSize: number) {
  try {
    const raw = sessionStorage.getItem(VISIBLE_COUNT_KEY);
    if (!raw) return pageSize;

    const cached = JSON.parse(raw) as { stateKey: string; visibleCount: number };
    return cached.stateKey === stateKey ? cached.visibleCount : pageSize;
  } catch {
    return pageSize;
  }
}

export function writeVisibleCount(stateKey: string, visibleCount: number) {
  try {
    sessionStorage.setItem(VISIBLE_COUNT_KEY, JSON.stringify({ stateKey, visibleCount }));
  } catch {
    // 저장 실패(용량 초과 등)는 복원만 포기하면 되므로 무시한다
  }
}
